<!--
 * @Description: 
 * @Author: Viga
 * @Date: 2025-09-17 13:57:30
 * @LastEditTime: 2026-01-29 13:40:32
-->
<template>
  <router-view></router-view>
</template>

<script setup>

</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
img {
  user-select: none;
  -webkit-user-drag: none; /* Chrome / Safari */
  user-drag: none;
  display: block;
}
</style>
